import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WeeklyPlannerCardDragService {
  constructor() {}

  private currentRow: HTMLElement;
  private currentRowDays: NodeListOf<HTMLElement>;

  // Monday = 0
  dayMouseReleasedOn(xCoordinate: number, plannerGroupId: string) {
    let indexOfDayDroppedOn: string = null;

    const groupRowElement = document.querySelector(`#planner-grid-group-row-${plannerGroupId}`) as HTMLElement;
    if (groupRowElement) {
      this.currentRow = groupRowElement;

      this.currentRowDays = this.currentRow.querySelectorAll('.main-weekday');

      this.currentRowDays?.forEach((day) => {
        const dayBoundingClient = day.getBoundingClientRect();

        if (dayBoundingClient.left < xCoordinate && dayBoundingClient.right > xCoordinate) {
          indexOfDayDroppedOn = day.getAttribute('data-day-id');
        }
      });
    }

    return  parseInt(indexOfDayDroppedOn, 10);
  }
}
